import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import {
  BrandOptionGroupDelivery,
  BrandOptionGroupEatIn,
  BrandOptionGroupTakeout,
} from '@/services/BrandOptionGroup/hooks';
import { MenuManagementBrandOptionGroupService } from '@/services/BrandOptionGroup/MenuManagementOptionGroupService';

export type ShowBrandOptionGroupResponse = {
  id: string;
  title: Title;
  memo: string | null;
  brand_item_sort_objects: SearchItem[];
  takeout: BrandOptionGroupTakeout | null;
  delivery: BrandOptionGroupDelivery | null;
  eat_in: BrandOptionGroupEatIn | null;
  quantity: {
    min: number;
    max: number | null;
    max_same_option: number | null;
  };
};

export const useMenuManagementBrandOptionGroupShow = async (
  id: string
): Promise<ShowBrandOptionGroupResponse> => {
  const menuManagementBrandOptionGroupService =
    new MenuManagementBrandOptionGroupService(getClient());
  try {
    const res = await menuManagementBrandOptionGroupService.show(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
